import React, { useState, useEffect, useRef } from "react"
import flameGif from "../../assets/images/flame-streak.gif"
import { useOverlayStyle } from "../Utility/useOverlayStyle"

// Per-level flame size (px) — badge colour already comes from the active-N class.
const FLAME_SIZES = [22, 24, 26, 28, 30, 32, 34, 36, 38, 40]

// ─── StreakBadge Component ─────────────────────────────────────────────────
const StreakBadge = React.memo(({ streak = 0, label = "Current Streak" }) => {

  const { cardHeaderStyle } = useOverlayStyle("ov");  

  const [pulseFlame, setPulseFlame] = useState(false)
  const [pulseBadge, setPulseBadge] = useState(false)
  const [showPlusOne, setShowPlusOne] = useState(false)
  const prevStreak = useRef(streak)

  useEffect(() => {
    if (streak > prevStreak.current) {
      setPulseFlame(true)
      setPulseBadge(true)
      setShowPlusOne(true)
      const t1 = setTimeout(() => setPulseFlame(false), 560)
      const t2 = setTimeout(() => setPulseBadge(false), 520)
      const t3 = setTimeout(() => setShowPlusOne(false), 900)
      prevStreak.current = streak
      return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3) }
    }
    prevStreak.current = streak
  }, [streak])

  const cap         = Math.min(streak, 10)
  const activeClass = streak > 0 ? ` active-${cap}` : ""
  const bumpClass   = pulseBadge ? " bump" : ""
  const active      = streak > 0
  const size        = active ? FLAME_SIZES[cap - 1] : 22

  return (
    <div className={`streak-badge${activeClass}${bumpClass}  border-right`}>
      {showPlusOne ? <span className="streak-plus-one">+1</span> : null}
      <div className={`streak-flame-wrap${pulseFlame ? " pulse" : ""}`}>
        {pulseFlame ? <span className="streak-flame-glow" /> : null}
        <img
          src={flameGif}
          alt=""
          aria-hidden="true"
          width={size}
          height={size}
          style={{
            display: "block",
            position: "relative",
            zIndex: 1,
            filter: active ? "none" : "grayscale(1) opacity(0.35)",
          }}
        />
      </div>
      <div className="streak-info" style={cardHeaderStyle}>
        <span className={`streak-count${streak === 0 ? " zero" : ""}`}>{streak}</span>
        <span className={`streak-sublabel${streak === 0 ? " zero" : ""}`}>{label}</span>
      </div>
    </div>
  )
})

export default StreakBadge
